import styled from 'styled-components';

export const PaymentModal = styled.div`
  padding: 30px;
  text-align: center;

  div {
    display: flex;
    justify-content: center;
    align-items: center;

    h2 {
      color: ${({ theme }) => theme.palette.primary.main};
    }
    p {
      color: ${({ theme }) => theme.palette.text.secondary};
    }
    button {
      margin: 5px 0;
    }
  }
`;
